import { resolveAssetUrl } from '../../services/apiClient'

export function adminImage(asset) {
  return asset?.url ? resolveAssetUrl(asset.url) : ''
}

export function formatAdminMoney(value) {
  if (typeof value !== 'number') return value
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value)
}

export function formatFeatureWindow(startsAt, endsAt) {
  if (!startsAt && !endsAt) return 'No schedule'

  const formatDate = (value) => value
    ? new Date(value).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
    : 'Now'

  return `${formatDate(startsAt)} to ${formatDate(endsAt)}`
}
